// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"0.1.20-2026-10-22T14:56:36.586Z"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://646eb7dda30c72849bb95fedfd2be890@o4507413325414400.ingest.us.sentry.io/4507879881244672",

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  integrations: [
    Sentry.feedbackIntegration({
      id: 'feedback-button',
      autoInject: false,
      colorScheme: "light",
      isNameRequired: true,
      isEmailRequired: true,
      showBranding: false,
      themeLight: {
        accentBackground: "#2d8dfe",
      },
      triggerLabel: "Feedback",
      submitButtonLabel: "Submit Feedback",
      formTitle: "Submit Feedback",
      messagePlaceholder: "For bug reports, please include: 1. What happened? 2. What is the expected behavior? 3. Steps to reproduce the issue. If this is related to an Assistant query, please include it.",
      emailPlaceholder: "",
      namePlaceholder: "",
      successMessageText: "Thank you for submitting your feedback!"
    }),
  ],
});